import { QrCodeDisplay, QrCodeDisplayLoader } from './QrCodeDisplay';


export const qrCodeRouter = {
  path: '/qr_code/:uid',
  id: 'qrcode',
  loader: QrCodeDisplayLoader,
  element: <QrCodeDisplay />,
};
